<template>
  <v-flex xs12>
    <v-autocomplete
      v-model="user"
      :label="labelName"
      placeholder="Digite el nombre del empleado"
      :loading="isLoading"
      :items="items"
      :search-input.sync="search"
      cache-items
      flat
      hide-no-data
      item-text="text"
      item-value="value"
      clearable
      required
      @blur="validator.user_id.$touch()"
      :error-messages="fatherNameErrors"
    ></v-autocomplete>
  </v-flex>
</template>

<script>
import config from "@/config";
import axios from "axios";
export default {
  props: {
    labelName: {
      type: String,
      required: true
    },
    user_id: {
      type: [String, Number],
      required: false
    },
    validator: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    items: [],
    model: null,
    search: null
  }),
  computed: {
    user: {
      get() {
        return this.user_id;
      },
      set(value) {
        this.$emit('set-user-name', value);
      }
    },
    fatherNameErrors() {
      const errors = [];
      if (!this.validator.user_id.$dirty) return errors;
      !this.validator.user_id.required && errors.push("El nombre de empleado es requerido.");
      return errors;
    },
  },
  watch: {
    search(val) {
      // Items have already been loaded
      let all_results = [];
      let all_ids = [];
      if (this.search == null || this.search.length < 5) return;
      this.isLoading = true;
      // Lazily load input items
      axios.get(`${process.env.VUE_APP_API_URL}/autocomplete_user?user=${this.search}`)
        .then(res => res.data)
        .then(res => {
          this.items = res;
        })
        .catch(err => {
          // console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style scoped>
.blue {
  background-color: #211850 !important;
  border-color: #211850 !important;
}
</style>